import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const NotificationsConfigListTable = ({
  children,
  count,
  company, ///////
  subcompany, ////////
  permissions, //////z
  handleToggle = () => {}, ///////
  handleOrderChange = () => {},
  order = '',
  orderBy = '',
  t,
}) => {
  const headers = [
    // { variable: "key", text: t("notification_config.fields.key") + ": ", type: "h3" },
    { variable: 'name', text: t('notification_config.fields.name') + ': ', type: 'h3' },
    { variable: 'send_mail', text: t('notification_config.fields.send_mail') + ': ' },
    // { variable: "description", text: t("notification_config.fields.description") + ": " },
    // { variable: "description", text: t("notification_config.fields.description") + ": " },
    {
      variable: 'active',
      text: t('notification_config.fields.active') + ': ',
      boolean: true,
    },
  ];

  const config = {
    actions: t('common.actions'), //Texto de seccion de acciones
    edit: t('common.edit'), //Texto de boton editar
    editPermission: 'acl.notifications_config.update',
    togglePermission: 'acl.notifications_config.toggle',
    editUrl: 'notification_config', //Url para editar empleado
    propsName: 'notificationConfig', //de donde se obtienen los props
    company: company,
    subcompany: subcompany,
  };

  const dataCard = {
    rows: children,
    headers: headers,
    config: config,
    permissions: permissions,
    handleClick: handleToggle,
  };
  return (
    <Common.List dataCard={dataCard}>
      <thead>
        <tr>
          {/* <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="key"
            handleOrderChange={handleOrderChange}
          >
            {t("notification_config.fields.key")}
          </Common.ThSortable> */}
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="name"
            handleOrderChange={handleOrderChange}
          >
            {t('notification_config.fields.name')}
          </Common.ThSortable>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="send_mail"
            handleOrderChange={handleOrderChange}
          >
            {t('notification_config.fields.send_mail')}
          </Common.ThSortable>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="destinatarios"
            handleOrderChange={handleOrderChange}
          >
            {t('notification_config.fields.destinatarios')}
          </Common.ThSortable>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="options"
            handleOrderChange={handleOrderChange}
          >
            {t('notification_config.fields.options')}
          </Common.ThSortable>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="active"
            handleOrderChange={handleOrderChange}
            className="text-center"
          >
            {t('notification_config.fields.active')}
          </Common.ThSortable>
          <th className="text-center">{t('common.actions')}</th>
        </tr>
      </thead>

      <tbody>
        {count === 0 && <Common.EmptyTable colSpan={10} />}
        {children}
      </tbody>
    </Common.List>
  );
};

export default translate()(NotificationsConfigListTable);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/components/list/NotificationsConfigListTable.js